import styled from 'styled-components';

export const StreamingWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.sm ?? '8px'};
  margin-top: ${(props) => props.theme.spacing?.sm ?? '8px'};
`;
